import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Assignment, Create, Search } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsFindBy } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import { InputAdornment, TextField } from '@material-ui/core';
import ModalSearch from './ModalSearch';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 150 } /* 150, 150, 150, 150, 5 */,
  { Header: 'Cód. Cliente', accessor: 'codCustomer', width: 150 },
  { Header: 'Cliente', accessor: 'customer' },
  { Header: 'Domicilio', accessor: 'address' },
  { Header: 'Ruta', accessor: 'base_route_description' },
  { Header: 'Estado', accessor: 'state', width: 150 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function CustomerRoute(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal(); //uso de las funciones del modal
  const [notify, showNotify] = useToasty(); //notificación despues de las acciones
  const [customerRoutes, setCustomerRoutes] = useState([]); //constante para el listado

  const [dataLoading, setDataLoading] = useState(false);
  const [showModaSearch, setShowModaSearch] = useState(false); //Abrir modal

  const [search, setSearch] = useState('');

  //recargar Listado para usar en create y update
  async function loadCustomerRoutes(search) {
    setDataLoading(true);
    let response = await wsFindBy('base/customer-route', 'base_route_description', search);
    setDataLoading(false);
    if (response.success) setCustomerRoutes(response.data);
  }

  return (
    <GridContainer>
      <Toasty action={notify} />
      <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={loadCustomerRoutes} />
      <ModalSearch
        showModal={showModaSearch}
        setShowModal={setShowModaSearch}
        search={loadCustomerRoutes}
        setSearch={setSearch}
      />

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Listado de Cliente Ruta {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={6}>
                <TextField
                  fullWidth
                  type="text"
                  name="code"
                  margin="normal"
                  placeholder="Ingrese ruta..."
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        style={{ cursor: 'pointer', color: '#07c107' }}
                        onClick={() => {
                          setShowModaSearch(true);
                          /* setRouteId(route.id); */
                        }}
                        position="start"
                      >
                        <Search />
                      </InputAdornment>
                    )
                  }}
                />
              </GridItem>
              <GridItem xs={6}>
                <Button
                  onClick={() => {
                    loadCustomerRoutes(search);
                  }}
                >
                  Buscar
                </Button>
              </GridItem>
            </GridContainer>
            <ReactTable
              excelName="Cliente-ruta"
              defaultWidth={1200}
              columns={columns}
              data={customerRoutes.map((customerRoute, i) => {
                //mapeando listado para las acciones
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.BASE_CUSTOMER_ROUTES_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorWarning}
                          onClick={() => setOpen(customerRoute)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.BASE_CUSTOMER_ROUTES_DELETED}>
                        <ButtonDelete
                          entity="base/customer-route"
                          id={customerRoute.id}
                          reload={loadCustomerRoutes}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  codCustomer: customerRoute.CardCode,
                  customer: customerRoute.CardName,
                  address: `${customerRoute.Address} - ${customerRoute.Address2}`,
                  base_route_description: `${customerRoute.base_route_code} - ${customerRoute.base_route_description}`,
                  state: customerRoute.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: ''
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
